<template>
  <a class="BackLink" :href="path">
    <span class="arrow" v-html="arrowLeftSvg" />
    {{ text }}
  </a>
</template>

<script>
import arrowLeftSvg from '~/assets/ui/arrow-left.svg?raw'

export default {
  props: {
    text: String,
    path: String,
  },
  data() {
    return {
      arrowLeftSvg,
    }
  },
}
</script>

<style scoped>
.BackLink {
  display: inline-block;
  font-size: var(--font-size-1);
  line-height: 1;
  color: var(--brand-color);
}
.arrow {
  margin-right: 0.75em;
  display: inline-block;
  vertical-align: middle;
}
</style>
